/** Figma: Grade Card (node 208:2011) */
export const gradeOptionLabels = [
  "PRE-K",
  "KINDERGARTEN",
  "GRADE 1",
  "GRADE 2",
  "GRADE 3",
  "GRADE 4",
  "GRADE 5",
  "GRADE 6",
  "GRADE 7",
  "GRADE 8",
  "GRADE 9",
  "GRADE 10",
  "GRADE 11",
  "GRADE 12",
  "UNDERGRADUATE",
  "POSTGRADUATE",
  "PROFESSIONAL",
];
